import styled from '@emotion/styled'

export const QPMInfoContainer = styled.div((props) => {
  const {
    theme: {
      color: { whitePrimary },
    },
  } = props

  return `
    height: 22px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    padding: 4px 6px;
    border-radius: 4px;
    border: thin solid #dfe0e2;
    background-color:${whitePrimary}
`
})

export const QPMText = styled.span((props) => {
  const {
    theme: {
      color: { greyPrimary },
    },
  } = props

  return `
    font-size: 12px;
    color:${greyPrimary}
  `
})

export const HelpImg = styled.img`
  width: 14px;
  height: 14px;
`
